import { isReconciled } from '../../../helpers/reconciliationHelpers';

export const validateForm = (
  entryType,
  formData,
  currentTransactions,
  categoriesArray,
  allPositive,
  allNegative,
  isBulkMode
) => {
  const newErrors = {};

  // Validar tipo de lançamento
  if (entryType === 'transfer') {
    // Para transferências, validar conta bancária de destino
    if (!formData.targetBankAccountId) {
      newErrors.targetBankAccountId = 'Conta bancária de destino é obrigatória para transferências';
    }

    // Categoria é opcional para transferências
  } else {
    // Para lançamentos regulares, validar categoria
    if (!formData.categoryId) {
      newErrors.categoryId = 'Categoria é obrigatória';
    }
  }

  // Descrição é opcional

  // Para modo bulk, descrições individuais também são opcionais

  // Validar que nenhuma transação já está conciliada
  const reconciledTransactions = currentTransactions.filter((txn) => isReconciled(txn));
  if (reconciledTransactions.length > 0) {
    newErrors.reconciled = `Não é possível criar lançamentos para transações já conciliadas. ${reconciledTransactions.length} transação(ões) já estão conciliadas.`;
  }

  // Validar que a categoria selecionada é compatível com o tipo das transações (apenas quando todas são do mesmo tipo)
  if (entryType === 'regular' && formData.categoryId) {
    const selectedCategory = categoriesArray.find((cat) => cat.id === formData.categoryId);
    if (selectedCategory) {
      // Só validar compatibilidade quando TODAS as transações são do mesmo tipo
      // Para transações mistas (allPositive=false e allNegative=false), qualquer categoria é válida
      if (allPositive && !selectedCategory.isInput) {
        newErrors.categoryId = 'A categoria selecionada não é compatível. Selecione uma categoria de entrada.';
      } else if (allNegative && selectedCategory.isInput) {
        newErrors.categoryId = 'A categoria selecionada não é compatível. Selecione uma categoria de saída.';
      }
    }
  }

  return newErrors;
};
